import { Box, Button, CircularProgress, SvgIcon, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { Col, Container, Row, NavLink } from 'react-bootstrap'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import './accountledger.css'

import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import PrintIcon from '@mui/icons-material/Print'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useSelector } from 'react-redux'
// import { getAccountLedgerdetails } from '../../../store/flight/action/accountLedgerAction';
import { API_BASE_URL } from '../../../utility/apiConstants'
import { getAuth } from '../../../utility/apiConfig'
import { Pagination } from '@mui/material';
import { formatDate2, IST_DDMMYYYY_T } from '../../../core/helper'
import exportFromJSON from 'export-from-json'
import ReactHtmlParser from 'react-html-parser'

const StyledTableCell = withStyles((theme) => ({ head: { backgroundColor: theme.palette.common.black, color: theme.palette.common.white }, body: { fontSize: 14 } }))(TableCell)

const StyledTableRow = withStyles((theme) => ({ root: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } } }))(TableRow)

const useStyles = makeStyles({ table: { minWidth: '100%' } })

const AccountLedger = () => {
  const classes = useStyles()
  const user = useSelector(state => state.user)
  const [isLoading, setIsLoading] = useState(false)

  const [accLegder, setAccLedger] = useState({
    fromdate: null,
    todate: null
  })

  const [accLedgerData, setAccLedgerData] = useState(null)
  const totalrecords = (accLedgerData) ? accLedgerData.total_records : 0
  const [activePage, setActivePage] = useState(1)

  const [isOpen, setIsOpen] = useState('')
  const [isToOpen, setIsToOpen] = useState('')

  const handleSearch = (val = 0) => {
    const data = {
      created_datetime_from: accLegder.fromdate,
      created_datetime_to: accLegder.todate,
      agent_id: user?.userDetails.user_id
    }
    try {
      setIsLoading(true)
      getAuth(API_BASE_URL + '/management/account_ledger/', { params: data })
        .then((response) => {
          const data = response.data.data
          setAccLedgerData(data)
          setIsLoading(false)
        })
        .catch((error) => { 
          setIsLoading(false)
        })
    } catch (error) {

    }
  }
  const handleSearch2 = (val) => {
    const data = {
      created_datetime_from: accLegder.fromdate,
      created_datetime_to: accLegder.todate,
      agent_id: user.userDetails.user_id
    }
    try {
      setIsLoading(true)
      const pagecount = (val == 1) ? 1 : (val - 1) * 20
      getAuth(API_BASE_URL + '/management/account_ledger/' + pagecount, { params: data })
        .then((response) => {
          const data = response.data.data
          setAccLedgerData(data)
          setIsLoading(false)
        })
        .catch((error) => { 
          setIsLoading(false)
        })
    } catch (error) {

    }
  }
  const handleReset = () => {
    window.location.reload()
  }

  const handleChange = (event, value) => {
    setActivePage(value) 
    handleSearch2(value)
  }

  const handleExport = () => {
    const data = {
      created_datetime_from: accLegder.fromdate,
      created_datetime_to: accLegder.todate,
      agent_id: user.userDetails.user_id
    }
    try {
      getAuth(API_BASE_URL + '/management/export_account_ledger/excel/', { params: data })
        .then((response) => { 
          if (response.data.status) {
            const accdata = []
            response.data.data.map((s, index) => {
              const accdataObj = {}
              accdataObj['Sl. No.'] = parseInt(index + 1)
              accdataObj.Date = s.transaction_date
              accdataObj['Reference Number'] = s.reference_number
              accdataObj.Description = s.full_description
              accdataObj.Debit = s.credit_amount
              accdataObj.Credit = s.debit_amount
             // accdataObj['Running Balance'] = s.closing_balance
              accdata.push(accdataObj)
            })
            const data = accdata
            const date = IST_DDMMYYYY_T()
            const fileName = 'accountLedger_' + date
            const exportType = 'xls'
            exportFromJSON({ data, fileName, exportType })
          }

          setIsLoading(false)
        })
        .catch((error) => { 
          setIsLoading(false)
        })
    } catch (error) {

    }
  }

  return (
    <div>

      <Container fluid className="ledgerContainer">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box className="tlt-ledger">Account Ledger</Box>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <form>
              <Row className="account-ledger">
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="zerogutterledger">
                  <MuiPickersUtilsProvider className="uiboxofdate" spacing={0} utils={DateFnsUtils}>
                    <KeyboardDatePicker className="editdob"
                      margin="normal"
                      variant="inline"
                      disableToolbar
                      autoOk
                      inputVariant="outlined"
                      size="small"
                      id="date-picker-dialog"
                      format="dd-MMM-yyyy"
                      value={accLegder.fromdate}
                      disableFuture
                      maxDate={new Date()}
                      emptyLabel="From Date"
                      onChange={(e) => setAccLedger({ ...accLegder, fromdate: e })}

                      onChange={(e) => {
                        setAccLedger({ ...accLegder, fromdate: e })
                        setIsOpen(false)
                      }}
                      KeyboardButtonProps={{
                        onFocus: e => {
                          setIsOpen(true)
                        }
                      }}
                      PopoverProps={{
                        disableRestoreFocus: true,
                        onClose: () => {
                          setIsOpen(false)
                        }
                      }}
                      InputProps={{
                        onFocus: () => {
                          setIsOpen(true)
                        }
                      }}
                      open={isOpen}

                    // KeyboardButtonProps={{
                    //     "aria-label": "change date"
                    // }}
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} className="zerogutterledger">
                  <MuiPickersUtilsProvider className="uiboxofdate" spacing={0} utils={DateFnsUtils}>
                    <KeyboardDatePicker className="editdob"
                      margin="normal"
                      variant="inline"
                      disableToolbar
                      autoOk
                      inputVariant="outlined"
                      size="small"
                      id="date-picker-dialog"
                      format="dd-MMM-yyyy"
                      value={accLegder.todate}
                      disableFuture
                      minDate={accLegder.fromdate}
                      maxDate={new Date()}
                      emptyLabel="To Date"
                      onChange={(e) => setAccLedger({ ...accLegder, todate: e })}

                      onChange={(e) => {
                        setAccLedger({ ...accLegder, todate: e })
                        setIsToOpen(false)
                      }}
                      KeyboardButtonProps={{
                        onFocus: e => {
                          setIsToOpen(true)
                        }
                      }}
                      PopoverProps={{
                        disableRestoreFocus: true,
                        onClose: () => {
                          setIsToOpen(false)
                        }
                      }}
                      InputProps={{
                        onFocus: () => {
                          setIsToOpen(true)
                        }
                      }}
                      open={isToOpen}

                    // KeyboardButtonProps={{
                    //     "aria-label": "change date"
                    // }}
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col xs={6} sm={6} md={2} lg={2} xl={2} className="zerogutterledger">
                  <Button
                    className="searchledger"
                    variant="contained"
                    color="primary"
                    onClick={handleSearch}
                    disabled={isLoading}
                  >{isLoading ? (<CircularProgress size={24} color="inherit" />) : 'Search'}</Button>
                </Col>
                <Col xs={6} sm={6} md={2} lg={2} xl={2} className="zerogutterledger">
                  <Button className="clearledger clear" variant="contained" onClick={handleReset}>Clear Filter</Button>
                </Col>
              </Row>
              {/* <Row>
                                <Box className="btnboxexport"><Button variant="contained" onClick={handleExport} color="primary" className="exportbtn">Export to excel</Button></Box>
                        </Row> */}
            </form>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {totalrecords
              ? <Button
                className="exportledger"
                variant="contained"
                color="primary"
                onClick={handleExport}
                disabled={isLoading}
              >{isLoading ? (<CircularProgress size={24} color="inherit" />) : 'Export to excel'}</Button>
              : ''}
          </Col>
          <Box className="tlt-content-ledger">Total {totalrecords} transaction found</Box>
          <Box className="table-box-found">
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label="customized table">
                <TableHead className="ledgertableheader">
                  <TableRow>
                    <StyledTableCell className="thledger" align="center">SI.No</StyledTableCell>
                    <StyledTableCell className="thledger" align="center">Date</StyledTableCell>
                    <StyledTableCell className="thledger" align="center">Reference Number</StyledTableCell>
                    <StyledTableCell className="thledger" align="center">Description</StyledTableCell>
                    <StyledTableCell className="thledger" align="center">Debit</StyledTableCell>
                    <StyledTableCell className="thledger" align="center">Credit</StyledTableCell>
                    {/* <StyledTableCell className="thledger" align="center">Running Balance</StyledTableCell> */}
                  </TableRow>
                </TableHead>
                {!!accLedgerData && (
                  
                  <TableBody>
                    {
                      isLoading
                        ? <StyledTableRow><StyledTableCell colspan="7" align="center"><CircularProgress size={24} color="inherit" /></StyledTableCell></StyledTableRow>
                        : accLedgerData.table_data.map((row, i) => {
                          
                         return <StyledTableRow key={i}>
                            <StyledTableCell className="tdledger" align="center">{(activePage == 1) ? i + 1 : ((activePage - 1) * 20) + (i + 1)}</StyledTableCell>
                            <StyledTableCell className="tdledger" align="center"><div style={{width: "max-content"}}>{formatDate2(row.transaction_date)}</div></StyledTableCell>
                            <StyledTableCell className="tdledger" align="center">{row.reference_number}
                              {
                                row.debit_amount && row.debit_amount > 0 && row.booking_source &&
                                <div className="invoice-voucher-div">
                                  <NavLink target="_blank" href={'/voucher?app_ref=' + row.reference_number + '&bookingid=' + row.booking_source.booking_source + '&status=' + row.booking_source.status + '&arg=show_voucher'}>
                                    <Box className="toollipicon">
                                      <Tooltip title="E-Ticket" arrow placement="top">
                                        <SvgIcon>
                                          <PrintIcon />
                                        </SvgIcon>
                                      </Tooltip>
                                    </Box>
                                  </NavLink>
                                  {/* <NavLink  target="_blank"  href={'/invoice?app_ref=' + row.reference_number + '&bookingid=' + row.booking_source.booking_source + '&status=' + row.booking_source.status + '&arg=show_voucher'}>
                                    <Box className="toollipicon">
                                      <Tooltip title="Invoice" arrow placement="top">
                                        <SvgIcon>
                                          <InsertDriveFileIcon />
                                        </SvgIcon>
                                      </Tooltip>
                                    </Box>
                                  </NavLink> */}
                                </div>
                              }
                            </StyledTableCell>
                            <StyledTableCell className="tdledger" align="left">{ReactHtmlParser(row.description)}<Box className="minitagledger">{row.transaction_details}</Box></StyledTableCell>
                            <StyledTableCell className="tdledger" align="center">{row.credit_amount}</StyledTableCell>
                            <StyledTableCell className="tdledger" align="center">{row.debit_amount}</StyledTableCell>
                            {/* <StyledTableCell className="tdledger" align="center">{row.closing_balance}</StyledTableCell> */}
                          </StyledTableRow>
})
                    }

                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
          <Box className="paginationbox">
            <Pagination count={Math.ceil(totalrecords / (!!accLedgerData && accLedgerData.per_page))} page={activePage} color="primary" onChange={handleChange} />
          </Box>
        </Row>
      </Container>
    </div>
  );
}

export default AccountLedger
